// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectListGroupDivider-divider__qX7u4{margin:0 var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "SelectListGroupDivider-divider__qX7u4"
};
export default ___CSS_LOADER_EXPORT___;
